/* FansBRANDS Order Support Core V20.3
 * Shared validation + customer-facing order status renderer.
 * Used by both the Help Center and the floating support chat.
 */
(function () {
  'use strict';

  if (window.FansBrandsOrderSupport) return;

  var FIELD_META = {
    order_number: {
      label: 'Rendelési szám',
      short: 'Rendelési szám',
      prompt: 'Írd be a rendelési számod',
      hint: 'A rendelés-visszaigazoló e-mailben találod. Példa: HU12345.',
      placeholder: 'HU12345',
      type: 'text',
      inputMode: 'text',
      autocomplete: 'off',
      maxLength: 40
    },
    email: {
      label: 'E-mail cím',
      short: 'E-mail cím',
      prompt: 'Írd be a rendeléskor használt e-mail címed',
      hint: 'Pontosan azt az e-mail címet add meg, amelyet a rendeléskor használtál.',
      placeholder: 'pelda@email.hu',
      type: 'email',
      inputMode: 'email',
      autocomplete: 'email',
      maxLength: 254
    },
    phone: {
      label: 'Telefonszám',
      short: 'Telefonszám',
      prompt: 'Írd be a rendeléskor megadott telefonszámod',
      hint: 'Előhívóval add meg. Példa: +36 70 123 4567.',
      placeholder: '+36 70 123 4567',
      type: 'tel',
      inputMode: 'tel',
      autocomplete: 'tel',
      maxLength: 32
    },
    postal_code: {
      label: 'Irányítószám',
      short: 'Irányítószám',
      prompt: 'Írd be a rendeléshez tartozó irányítószámot',
      hint: 'A szállítási vagy számlázási cím irányítószámát add meg.',
      placeholder: '1111',
      type: 'text',
      inputMode: 'text',
      autocomplete: 'postal-code',
      maxLength: 16
    }
  };

  function cleanText(value) {
    return String(value || '')
      .replace(/[\u00A0\u2000-\u200D\u202F\u205F\u3000]/g, ' ')
      .trim();
  }

  function normalize(type, value) {
    var raw = cleanText(value);

    if (type === 'order_number') {
      var upper = raw.toUpperCase();
      var embedded = upper.match(/HU[\s#-]*\d{2,}/i);
      if (embedded) return embedded[0].replace(/[\s#-]+/g, '').toUpperCase();
      return upper.replace(/^#+/, '').replace(/\s+/g, '');
    }

    if (type === 'email') {
      return raw.replace(/\s+/g, '').toLowerCase();
    }

    if (type === 'phone') {
      var compact = raw.replace(/[\s().\-\/]/g, '');
      if (!/^[+\d]+$/.test(compact)) return compact;
      if (/^00\d+/.test(compact)) compact = '+' + compact.slice(2);
      if (/^06\d+/.test(compact)) compact = '+36' + compact.slice(2);
      if (/^36\d{8,9}$/.test(compact)) compact = '+' + compact;
      return compact;
    }

    if (type === 'postal_code') {
      return raw.toUpperCase().replace(/\s+/g, ' ').replace(/\s*-\s*/g, '-');
    }

    return raw;
  }

  function isFansBrandsInternalEmail(email) {
    var normalizedEmail = normalize('email', email);
    var parts = normalizedEmail.split('@');
    if (parts.length !== 2) return false;

    var domain = String(parts[1] || '').toLowerCase().replace(/\.$/, '');
    if (!domain) return false;

    // Tiltjuk a FansBRANDS saját e-mail domainjeit minden piacon,
    // valamint azok aldomainjeit (pl. mail.fansbrands.hu).
    return domain.indexOf('fansbrands.') === 0 || domain.indexOf('.fansbrands.') !== -1;
  }

  function emailTypoSuggestion(email) {
    var parts = email.split('@');
    if (parts.length !== 2) return '';
    var domain = (parts[1] || '').toLowerCase();
    var known = {
      'gamil.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com',
      'gmail.co': 'gmail.com', 'gmail.hu': 'gmail.com', 'hotnail.com': 'hotmail.com',
      'hotmai.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'outlok.com': 'outlook.com',
      'outllok.com': 'outlook.com', 'outlook.co': 'outlook.com', 'yaho.com': 'yahoo.com',
      'yahoo.co': 'yahoo.com', 'icloud.co': 'icloud.com'
    };
    return known[domain] || '';
  }

  function validate(type, value) {
    var v = normalize(type, value);

    if (!v) return { error: 'Töltsd ki ezt a mezőt.', value: '' };

    if (type === 'order_number') {
      if (v.indexOf('@') !== -1) return { error: 'Úgy tűnik, e-mail címet írtál a rendelési szám helyére.', value: v };
      if (v.length < 3 || v.length > 40 || !/^[A-Z0-9_-]+$/.test(v)) {
        return { error: 'A rendelési szám formátuma nem megfelelő. Példa: HU12345.', value: v };
      }
    }

    if (type === 'email') {
      if (v.length > 254) return { error: 'A megadott e-mail cím túl hosszú.', value: v };
      if ((v.match(/@/g) || []).length !== 1 || !/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(v)) {
        return { error: 'Az e-mail cím formátuma nem megfelelő. Példa: nev@email.hu.', value: v };
      }
      if (isFansBrandsInternalEmail(v)) {
        return {
          error: 'FansBRANDS belső e-mail címmel nem indítható rendeléslekérdezés. Kérlek, a rendeléskor használt vásárlói e-mail címet add meg.',
          value: v
        };
      }

      var suggestion = emailTypoSuggestion(v);
      if (suggestion) {
        var local = v.split('@')[0];
        return { error: 'Lehet, hogy elírtad az e-mail szolgáltatót. Erre gondoltál: ' + local + '@' + suggestion + '?', value: v };
      }
    }

    if (type === 'phone') {
      if (/[A-Za-zÁÉÍÓÖŐÚÜŰáéíóöőúüű]/.test(v)) {
        return { error: 'A telefonszám nem tartalmazhat betűket.', value: v };
      }
      if (!/^\+\d{8,15}$/.test(v)) {
        var digits = String(value || '').replace(/\D/g, '');
        if (/^(1\d{7}|(?:20|30|31|50|70)\d{7})$/.test(digits)) {
          return { error: 'Hiányzik a telefonszám előhívója. Példa: +36 70 123 4567.', value: v };
        }
        return { error: 'A telefonszámot előhívóval add meg. Példa: +36 70 123 4567.', value: v };
      }
    }

    if (type === 'postal_code') {
      if (v.length < 2 || v.length > 12 || !/^[A-Z0-9][A-Z0-9 -]*[A-Z0-9]$/.test(v)) {
        return { error: 'Az irányítószám formátuma nem megfelelő.', value: v };
      }
    }

    return { error: '', value: v };
  }

  function secondaryKeys(primary) {
    if (primary === 'order_number') return ['email', 'phone', 'postal_code'];
    if (primary === 'email') return ['order_number', 'phone', 'postal_code'];
    return [];
  }

  function configureInput(input, type) {
    var meta = FIELD_META[type];
    if (!input || !meta) return;
    input.type = meta.type;
    input.inputMode = meta.inputMode;
    input.autocomplete = meta.autocomplete;
    input.maxLength = meta.maxLength;
    input.placeholder = meta.placeholder;
    input.autocapitalize = type === 'order_number' ? 'characters' : 'none';
    input.spellcheck = false;
    input.value = '';
  }

  function safeUrl(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      var u = new URL(value);
      return u.protocol === 'https:' && !u.username && !u.password ? u.href : '';
    } catch (_) {
      return '';
    }
  }

  function upper(value) { return String(value || '').toUpperCase(); }

  function budapestDateParts(value) {
    if (!value) return null;
    var date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return null;
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(date);
      var out = {};
      parts.forEach(function (p) { if (p.type !== 'literal') out[p.type] = p.value; });
      return { year: Number(out.year), month: Number(out.month), day: Number(out.day) };
    } catch (_) {
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
  }

  function ymd(parts) {
    if (!parts) return '';
    return String(parts.year).padStart(4, '0') + '-' + String(parts.month).padStart(2, '0') + '-' + String(parts.day).padStart(2, '0');
  }

  function partsFromYmd(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    return m ? { year: Number(m[1]), month: Number(m[2]), day: Number(m[3]) } : null;
  }

  function utcDateFromParts(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  }

  function addCalendarDays(parts, days) {
    var d = utcDateFromParts(parts);
    d.setUTCDate(d.getUTCDate() + days);
    return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
  }

  function easterSundayParts(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return { year: year, month: month, day: day };
  }

  function hungarianHolidaySet(year) {
    var fixed = [
      year + '-01-01', year + '-03-15', year + '-05-01', year + '-08-20',
      year + '-10-23', year + '-11-01', year + '-12-25', year + '-12-26'
    ];
    var easter = easterSundayParts(year);
    fixed.push(ymd(addCalendarDays(easter, -2))); // nagypéntek
    fixed.push(ymd(addCalendarDays(easter, 1)));  // húsvéthétfő
    fixed.push(ymd(addCalendarDays(easter, 50))); // pünkösdhétfő

    // 2026 hivatalos, áthelyezett pihenőnapok.
    if (year === 2026) fixed.push('2026-01-02', '2026-08-21', '2026-12-24');
    return new Set(fixed);
  }

  function isHungarianWorkday(parts) {
    var key = ymd(parts);
    // 2026 hivatalos, áthelyezett szombati munkanapok.
    if (key === '2026-01-10' || key === '2026-08-08' || key === '2026-12-12') return true;
    var d = utcDateFromParts(parts);
    var day = d.getUTCDay();
    if (day === 0 || day === 6) return false;
    return !hungarianHolidaySet(parts.year).has(key);
  }

  function nextHungarianWorkday(parts) {
    var cur = addCalendarDays(parts, 1);
    while (!isHungarianWorkday(cur)) cur = addCalendarDays(cur, 1);
    return cur;
  }

  function addHungarianWorkdays(parts, count) {
    var cur = { year: parts.year, month: parts.month, day: parts.day };
    var added = 0;
    while (added < count) {
      cur = addCalendarDays(cur, 1);
      if (isHungarianWorkday(cur)) added += 1;
    }
    return cur;
  }

  function compareParts(a, b) {
    return utcDateFromParts(a).getTime() - utcDateFromParts(b).getTime();
  }

  function businessDaysInclusive(start, end) {
    if (compareParts(start, end) > 0) return 0;
    var cur = { year: start.year, month: start.month, day: start.day };
    var count = 0;
    while (compareParts(cur, end) <= 0) {
      if (isHungarianWorkday(cur)) count += 1;
      cur = addCalendarDays(cur, 1);
    }
    return count;
  }

  function calendarDaysRemaining(today, deadline) {
    return Math.max(0, Math.ceil((utcDateFromParts(deadline) - utcDateFromParts(today)) / 86400000));
  }

  function pickupModel(data) {
    data = data || {};
    var readySource = data.pickupReadyAt || (upper(data.deliveryStatus) === 'READY_FOR_PICKUP' ? data.deliveryHappenedAt : null);
    var ready = budapestDateParts(readySource);
    var mode = String(data.pickupRetentionMode || '');
    var days = Number(data.pickupRetentionDays || 0);
    var type = String(data.pickupType || '');
    if (!ready || !mode || !days || (type !== 'parcel_point' && type !== 'locker')) return null;

    var deadline = mode === 'business' ? addHungarianWorkdays(ready, days) : addCalendarDays(ready, days);
    var today = budapestDateParts(new Date());
    if (!today) return null;

    var expired = compareParts(today, deadline) > 0;
    var remaining;
    var unit;

    if (mode === 'business') {
      var firstCounted = nextHungarianWorkday(ready);
      var start = compareParts(today, firstCounted) < 0 ? firstCounted : today;
      remaining = expired ? 0 : businessDaysInclusive(start, deadline);
      unit = remaining === 1 ? 'munkanap' : 'munkanap';
    } else {
      remaining = expired ? 0 : calendarDaysRemaining(today, deadline);
      unit = remaining === 1 ? 'nap' : 'nap';
    }

    return {
      type: type,
      label: data.pickupLabel || (type === 'locker' ? 'Csomagautomata' : 'CsomagPont'),
      mode: mode,
      days: days,
      readyDate: ymd(ready),
      deadlineDate: ymd(deadline),
      remaining: remaining,
      unit: unit,
      expired: expired,
      urgent: !expired && remaining <= 1
    };
  }

  function statusModel(data) {
    data = data || {};
    var delivery = upper(data.deliveryStatus);
    var fulfillment = upper(data.fulfillmentStatus);
    var carrierName = (data.tracking && data.tracking.company) || data.carrier || '';
    var carrierPage = carrierName ? carrierName + ' nyomkövetési oldalán' : 'futár nyomkövetési oldalán';

    if (data.cancelled) {
      return {
        key: 'cancelled', tone: 'red', label: 'Rendelés törölve',
        message: 'A rendelésed törölve lett, ezért nem kerül csomagolásra vagy kiszállításra.',
        problem: true, showTracking: false
      };
    }

    if (delivery === 'ATTEMPTED_DELIVERY') {
      return {
        key: 'attempted_delivery', tone: 'red', label: 'Sikertelen kézbesítés',
        message: 'A futár megpróbálta kézbesíteni a csomagot, de a kézbesítés nem sikerült. Nézd meg a részleteket a ' + carrierPage + ', vagy kérj segítséget WhatsAppon.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'FAILURE' || delivery === 'NOT_DELIVERED' || delivery === 'CANCELED') {
      return {
        key: 'delivery_problem', tone: 'red', label: 'Kézbesítési probléma',
        message: 'A futárszolgálat problémát jelzett a kézbesítésnél. Ellenőrizd a részleteket a ' + carrierPage + ', vagy írj nekünk WhatsAppon.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'DELAYED') {
      return {
        key: 'delayed', tone: 'red', label: 'Késik a csomag',
        message: 'A futárszolgálat késést jelzett. A legfrissebb információt a ' + carrierPage + ' találod.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'DELIVERED') {
      return {
        key: 'delivered', tone: 'green', label: 'Kézbesítve',
        message: 'A futárszolgálat adatai szerint a csomagot kézbesítették. Ha mégsem kaptad meg, írj nekünk WhatsAppon.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'OUT_FOR_DELIVERY') {
      return {
        key: 'out_for_delivery', tone: 'blue', label: 'Kézbesítés alatt',
        message: 'A csomagod kézbesítés alatt van. FONTOS: a futárszolgálat oldalán láthatod a legfrissebb kézbesítési információkat és – ha elérhető – a várható kézbesítési időablakot. Érdemes a megadott időszakban a kézbesítési címen elérhetőnek lenned.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'IN_TRANSIT' || delivery === 'CARRIER_PICKED_UP') {
      return {
        key: 'in_transit', tone: 'blue', label: 'Úton hozzád',
        message: 'A csomagod már a futárszolgálatnál van. FONTOS: a futárszolgálat oldalán tudod megnézni a legfrissebb kézbesítési információkat és – ha elérhető – a várható kézbesítési időablakot. Ha aznapra jelzik a kézbesítést, érdemes a kézbesítési címen elérhetőnek lenned.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'READY_FOR_PICKUP') {
      var pickup = pickupModel(data);
      if (pickup && pickup.expired) {
        return {
          key: 'pickup_expired', tone: 'red', label: 'Átvételi határidő lejárt',
          message: 'Az átvételi határidő lejárt. Elképzelhető, hogy a csomagot már visszaküldik hozzánk. Ellenőrizd a futár oldalát, vagy kérj segítséget WhatsAppon.',
          problem: true, showTracking: true
        };
      }
      return {
        key: 'ready_for_pickup', tone: 'blue', label: 'Átvételre kész',
        message: pickup
          ? 'A csomagod megérkezett a ' + pickup.label + ' átvételi helyre. Vedd át a megadott határidőn belül.'
          : 'A csomag átvehető. A pontos átvételi információkat a futár vagy az átvételi pont értesítésében találod.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'PICKED_UP') {
      return {
        key: 'picked_up', tone: 'green', label: 'Átvéve',
        message: 'A rendszer adatai szerint a csomagot átvették. Ha ez nem történt meg, írj nekünk WhatsAppon.',
        problem: false, showTracking: false
      };
    }

    if (delivery === 'LABEL_VOIDED') {
      return {
        key: 'label_voided', tone: 'yellow', label: 'Szállítás előkészítés alatt',
        message: 'A korábbi szállítási címkét érvénytelenítették. A rendelésedet továbbra is feldolgozzuk.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'FULFILLED' || delivery === 'FULFILLED' || delivery === 'MARKED_AS_FULFILLED' || delivery === 'LABEL_PRINTED' || delivery === 'LABEL_PURCHASED' || delivery === 'CONFIRMED' || delivery === 'SUBMITTED') {
      return {
        key: 'packed', tone: 'yellow', label: 'Csomagolva',
        message: 'A rendelésedet összekészítettük. A következő lépés a futárnak történő átadás.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'IN_PROGRESS') {
      return {
        key: 'packing', tone: 'yellow', label: 'Csomagolás alatt',
        message: 'Dolgozunk a rendeléseden és készítjük össze a csomagot. Most nincs teendőd.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'PARTIALLY_FULFILLED') {
      return {
        key: 'partially_packed', tone: 'yellow', label: 'Részben csomagolva',
        message: 'A rendelésed egy részét már összekészítettük. Ha több csomag tartozik hozzá, külön nyomkövetési információk érkezhetnek.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'ON_HOLD') {
      return {
        key: 'on_hold', tone: 'yellow', label: 'Ellenőrzés alatt',
        message: 'A rendelésed átmenetileg ellenőrzés alatt van. Ha ez hosszabb ideig nem változik, kérj segítséget WhatsAppon.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'FULFILLMENT_NOT_REQUIRED') {
      return {
        key: 'no_shipping', tone: 'yellow', label: 'Nincs csomagolás',
        message: 'Ehhez a rendeléshez a rendszer szerint nem szükséges fizikai csomagküldés.',
        problem: false, showTracking: false
      };
    }

    return {
      key: 'processing', tone: 'yellow', label: 'Feldolgozás alatt',
      message: 'Megkaptuk a rendelésedet és jelenleg feldolgozzuk. Most nincs teendőd.',
      problem: false, showTracking: false
    };
  }

  function paymentMethodLabel(name) {
    var raw = String(name || '').trim();
    if (!raw) return '';
    if (/^shopify[_\s-]*payments$/i.test(raw)) return 'Bankkártya';
    return raw;
  }

  function paymentModel(data) {
    data = data || {};
    var status = upper(data.financialStatus);
    var gateways = Array.isArray(data.paymentGatewayNames) ? data.paymentGatewayNames.filter(Boolean) : [];
    var isCod = data.isCod === true || gateways.some(function (name) {
      return /cash\s*on\s*delivery|\bcod\b|ut[aá]nv[eé]t/i.test(String(name));
    });
    var method = isCod ? 'Utánvét' : paymentMethodLabel(gateways[0]);

    if (isCod && status === 'PENDING') {
      var pickupType = String(data.pickupType || '').toLowerCase();
      var codMessage = pickupType
        ? 'A csomagot átvételkor kell kifizetned. Az átvételi hely fizetési lehetőségeit a futár értesítésében ellenőrizd.'
        : 'A csomagot átvételkor kell kifizetned. A futárnál készpénzzel vagy bankkártyával is fizethetsz.';
      return {
        key: 'cod', label: 'Utánvét', method: 'Utánvét',
        message: codMessage
      };
    }
    if (status === 'PAID') return { key: 'paid', label: 'Fizetve', method: method, message: 'Nincs további fizetési teendőd.' };
    if (status === 'AUTHORIZED') return { key: 'authorized', label: 'Fizetés engedélyezve', method: method, message: 'A fizetés engedélyezve van. Jelenleg nincs teendőd.' };
    if (status === 'PARTIALLY_PAID') return { key: 'partial', label: 'Részben fizetve', method: method, message: 'A rendelés értékének csak egy része van kifizetve.' };
    if (status === 'REFUNDED') return { key: 'refunded', label: 'Visszatérítve', method: method, message: 'A fizetést visszatérítettük.' };
    if (status === 'PARTIALLY_REFUNDED') return { key: 'partial_refund', label: 'Részben visszatérítve', method: method, message: 'A rendelés összegének egy részét visszatérítettük.' };
    if (status === 'VOIDED') return { key: 'voided', label: 'Érvénytelenítve', method: method, message: 'A fizetést érvénytelenítettük.' };
    if (status === 'EXPIRED') return { key: 'expired', label: 'Fizetés lejárt', method: method, message: 'A fizetés nem zárult le időben. Ha segítségre van szükséged, írj nekünk WhatsAppon.' };
    if (status === 'PENDING') return { key: 'pending', label: 'Fizetésre vár', method: method, message: 'A fizetés még nincs lezárva. Ha ezt nem vártad, kérj segítséget WhatsAppon.' };
    return { key: 'unknown', label: 'Fizetés', method: method, message: 'A fizetési információ jelenleg nem áll rendelkezésre.' };
  }

  function formatDate(value) {
    if (!value) return '–';
    try {
      return new Intl.DateTimeFormat('hu-HU', { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(value));
    } catch (_) { return String(value); }
  }

  function formatMoney(money) {
    if (!money || money.amount == null) return '–';
    var currency = money.currencyCode || 'HUF';
    try {
      return new Intl.NumberFormat('hu-HU', {
        style: 'currency', currency: currency, maximumFractionDigits: currency === 'HUF' ? 0 : 2
      }).format(Number(money.amount));
    } catch (_) {
      return money.amount + ' ' + currency;
    }
  }

  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function whatsappUrl(baseUrl, data, status) {
    var safe = safeUrl(baseUrl);
    if (!safe) return '';
    try {
      var u = new URL(safe);
      var message = 'Szia! Segítséget szeretnék kérni';
      if (data && data.name) message += ' a ' + data.name + ' rendeléssel kapcsolatban';
      if (status && status.label) message += '. Státusz: ' + status.label;
      message += '.';
      u.searchParams.set('text', message);
      return u.href;
    } catch (_) { return safe; }
  }

  function appendWhatsApp(container, baseUrl, data, status, strong) {
    var href = whatsappUrl(baseUrl, data, status);
    if (!href) return;
    var a = el('a', strong ? 'fb-order-whatsapp is-strong' : 'fb-order-whatsapp', strong ? 'SEGÍTSÉGET KÉREK WHATSAPPON' : 'Kérdésed van? Írj nekünk WhatsAppon');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    container.appendChild(a);
  }

  function formatDateOnly(value) {
    var p = partsFromYmd(value);
    if (!p) return 'Még nincs adat';
    try {
      return new Intl.DateTimeFormat('hu-HU', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
      }).format(utcDateFromParts(p));
    } catch (_) { return value; }
  }

  function appendPickupCountdown(container, data, status, options) {
    if (upper(data.deliveryStatus) !== 'READY_FOR_PICKUP') return;
    var pickup = pickupModel(data);
    if (!pickup) return;

    var box = el('div', 'fb-order-view__pickup' + (pickup.expired ? ' is-expired' : (pickup.urgent ? ' is-urgent' : '')));
    var top = el('div', 'fb-order-view__pickup-top');
    var copy = el('div');
    copy.appendChild(el('span', '', pickup.label === 'GLS Automata' ? 'ÁTVÉTELI IDŐ – GLS AUTOMATA' : 'ÁTVÉTELI IDŐ – GLS CSOMAGPONT'));
    copy.appendChild(el('strong', '', pickup.expired ? 'Az átvételi határidő lejárt' : ('Még ' + pickup.remaining + ' ' + pickup.unit + ' az átvételre')));
    top.appendChild(copy);
    box.appendChild(top);

    var dates = el('div', 'fb-order-view__pickup-dates');
    var arrived = el('div');
    arrived.appendChild(el('span', '', 'Átvételre érkezett'));
    arrived.appendChild(el('strong', '', formatDateOnly(pickup.readyDate)));
    var deadline = el('div');
    deadline.appendChild(el('span', '', 'Átvételi határidő'));
    deadline.appendChild(el('strong', '', formatDateOnly(pickup.deadlineDate)));
    dates.append(arrived, deadline);
    box.appendChild(dates);

    var noteWrap = el('div', 'fb-order-view__pickup-note');
    noteWrap.appendChild(el('p', '', pickup.mode === 'business'
      ? 'A GLS CsomagPontnál az átvételi idő 5 munkanap.'
      : 'A GLS Automatában a tárolási idő 7 naptári nap.'));
    var important = el('p', 'fb-order-view__pickup-important');
    important.appendChild(el('strong', 'fb-order-important', 'FONTOS:'));
    important.appendChild(document.createTextNode(' A GLS értesítésében szereplő átvételi határidő az irányadó.'));
    noteWrap.appendChild(important);
    box.appendChild(noteWrap);

    container.appendChild(box);
  }

  function appendStatusMessage(container, status, data) {
    var box = el('div', 'fb-order-view__message fb-order-view__message--structured');

    function addParagraph(text, className) {
      if (!text) return;
      box.appendChild(el('p', className || '', text));
    }

    function addImportant(text) {
      var p = el('p', 'fb-order-view__important-line');
      p.appendChild(el('strong', 'fb-order-important', 'FONTOS:'));
      p.appendChild(document.createTextNode(' ' + text));
      box.appendChild(p);
    }

    if (status.key === 'in_transit') {
      addParagraph('A csomagod már a futárszolgálatnál van.', 'fb-order-view__message-title');
      addImportant('A futár oldalán tudod megnézni a legfrissebb kézbesítési információkat és – ha elérhető – a várható kézbesítési időablakot.');
      addParagraph('Ha aznapra jelzik a kézbesítést, érdemes a kézbesítési címen elérhetőnek lenned.');
    } else if (status.key === 'out_for_delivery') {
      addParagraph('A csomagod kézbesítés alatt van.', 'fb-order-view__message-title');
      addImportant('A futár oldalán ellenőrizd a várható érkezési időt vagy időablakot.');
      addParagraph('Érdemes a kézbesítési címen elérhetőnek lenned.');
    } else if (status.key === 'ready_for_pickup') {
      addParagraph('A csomagod átvehető az átvételi ponton.', 'fb-order-view__message-title');
      addImportant('Vedd át a csomagot a lent jelzett átvételi határidőig. A futár értesítésében szereplő határidő az irányadó.');
    } else if (status.key === 'pickup_expired') {
      addParagraph('Az átvételi határidő lejárt.', 'fb-order-view__message-title');
      addImportant('Elképzelhető, hogy a csomagot már visszaküldik hozzánk.');
      addParagraph('Ellenőrizd a futár oldalát, vagy kérj segítséget WhatsAppon.');
    } else if (status.key === 'attempted_delivery' || status.key === 'delivery_problem' || status.key === 'delayed') {
      addParagraph(status.message, 'fb-order-view__message-title');
      addImportant('Ellenőrizd a futár nyomkövetési oldalát. Ha nem egyértelmű a következő lépés, írj nekünk WhatsAppon.');
    } else {
      addParagraph(status.message);
    }

    container.appendChild(box);
  }

  function renderOrder(container, data, options) {
    options = options || {};
    if (!container) return;
    var status = statusModel(data);
    var payment = paymentModel(data);
    var tracking = data && data.tracking ? data.tracking : {};
    var trackingUrl = safeUrl(tracking.url);
    var carrier = tracking.company || data.carrier || '';

    container.replaceChildren();
    container.classList.add('fb-order-view');

    var head = el('div', 'fb-order-view__head');
    var id = el('div', 'fb-order-view__identity');
    id.appendChild(el('span', 'fb-order-view__eyebrow', 'RENDELÉS'));
    id.appendChild(el('strong', 'fb-order-view__name', data.name || 'Rendelés'));
    head.appendChild(id);
    head.appendChild(el('span', 'fb-order-badge is-' + status.tone, status.label));
    container.appendChild(head);

    appendStatusMessage(container, status, data);

    if (data.cancelled) {
      appendWhatsApp(container, options.whatsappUrl, data, status, true);
      container.hidden = false;
      return;
    }

    var meta = el('div', 'fb-order-view__meta');
    var dateBox = el('div', 'fb-order-view__meta-item');
    dateBox.appendChild(el('span', '', 'Rendelés dátuma'));
    dateBox.appendChild(el('strong', '', formatDate(data.processedAt || data.createdAt)));
    var totalBox = el('div', 'fb-order-view__meta-item');
    totalBox.appendChild(el('span', '', 'Rendelés értéke'));
    totalBox.appendChild(el('strong', '', formatMoney(data.total)));
    meta.append(dateBox, totalBox);

    var pickup = pickupModel(data);
    var pickupReadySource = data.pickupReadyAt || (upper(data.deliveryStatus) === 'READY_FOR_PICKUP' ? data.deliveryHappenedAt : null);
    var isReadyPickup = upper(data.deliveryStatus) === 'READY_FOR_PICKUP' && !!pickupReadySource;
    var isDelivered = status.key === 'delivered' || upper(data.deliveryStatus) === 'DELIVERED';
    var deliveredSource = data.deliveredAt || (isDelivered ? data.deliveryHappenedAt : null);

    var expectedLabel = '';
    var expectedValue = '';

    // Csak ténylegesen rendelkezésre álló dátumot mutatunk.
    // A Shopify a GLS várható kézbesítési idejét nem feltétlenül adja át.
    if (isDelivered && budapestDateParts(deliveredSource)) {
      expectedLabel = 'Kiszállítva';
      expectedValue = formatDate(deliveredSource);
    } else if (isReadyPickup && budapestDateParts(pickupReadySource)) {
      expectedLabel = 'Átvételre érkezett';
      expectedValue = formatDate(pickupReadySource);
    } else if (!isDelivered && !isReadyPickup && budapestDateParts(data.estimatedDeliveryAt)) {
      expectedLabel = data.pickupType ? 'Várható érkezés az átvételi pontra' : 'Várható kézbesítés';
      expectedValue = formatDate(data.estimatedDeliveryAt);
    }

    if (expectedLabel && expectedValue) {
      var expectedBox = el('div', 'fb-order-view__meta-item fb-order-view__meta-item--expected');
      expectedBox.appendChild(el('span', '', expectedLabel));
      expectedBox.appendChild(el('strong', '', expectedValue));
      meta.appendChild(expectedBox);
    }
    container.appendChild(meta);

    var pay = el('div', 'fb-order-view__payment');
    var payTop = el('div', 'fb-order-view__payment-top');
    payTop.appendChild(el('span', '', 'Fizetés'));
    payTop.appendChild(el('strong', '', payment.label));
    pay.appendChild(payTop);
    if (payment.method && payment.method !== payment.label) pay.appendChild(el('small', '', 'Fizetési mód: ' + payment.method));
    pay.appendChild(el('p', '', payment.message));
    container.appendChild(pay);

    appendPickupCountdown(container, data, status, options);

    var hasTracking = !!(tracking.number || trackingUrl || carrier);
    if (hasTracking || status.showTracking) {
      var ship = el('div', 'fb-order-view__shipping');
      if (carrier) {
        var carrierBox = el('div');
        carrierBox.appendChild(el('span', '', 'Futárszolgálat'));
        carrierBox.appendChild(el('strong', '', carrier));
        ship.appendChild(carrierBox);
      }
      if (tracking.number) {
        var trackBox = el('div');
        trackBox.appendChild(el('span', '', 'Nyomkövetési szám'));
        trackBox.appendChild(el('strong', '', tracking.number));
        ship.appendChild(trackBox);
      }
      if (trackingUrl) {
        var isGls = /gls/i.test(String(carrier || ''));
        if (status.key === 'in_transit' || status.key === 'out_for_delivery') {
          var actionBox = el('div');
          actionBox.style.gridColumn = '1 / -1';
          actionBox.appendChild(el('span', '', 'Kézbesítési információk'));
          actionBox.appendChild(el('strong', '', isGls
            ? 'A GLS oldalán találod a legfrissebb csomaginformációkat és – ha elérhető – a várható kézbesítési időablakot. A részletes adatokhoz szükség lehet a kézbesítési irányítószámodra.'
            : 'A futár oldalán találod a legfrissebb csomaginformációkat és – ha elérhető – a várható kézbesítési időablakot. A részletes adatokhoz szükség lehet a kézbesítési irányítószámodra.'));
          ship.appendChild(actionBox);
        }
        var buttonLabel = isGls ? 'GLS NYOMKÖVETÉS MEGNYITÁSA'
          : (carrier ? carrier.toUpperCase() + ' NYOMKÖVETÉS MEGNYITÁSA' : 'CSOMAGOM NYOMON KÖVETÉSE');
        var button = el('a', 'fb-order-track-button', buttonLabel);
        button.href = trackingUrl;
        button.target = '_blank';
        button.rel = 'noopener noreferrer';
        // A nyomkövetési gomb a futáradatok elé kerül, hogy könnyen megtalálható legyen.
        ship.prepend(button);
      }
      // A futár oldalára vezető hivatkozás az első képernyőn is könnyebben elérhető.
      container.insertBefore(ship, meta);
    }

    appendWhatsApp(container, options.whatsappUrl, data, status, status.problem || status.key === 'delivered');
    container.hidden = false;
  }

  function noMatchMessage(secondType) {
    var labels = {
      email: 'e-mail címet', phone: 'telefonszámot', postal_code: 'irányítószámot', order_number: 'rendelési számot'
    };
    var label = labels[secondType] || 'második adatot';
    return 'A két megadott adat együtt nem egyezik egy rendelésünkkel. Ellenőrizd különösen a ' + label + '. Biztonsági okból nem jelezzük külön, hogy melyik adat található meg a rendszerben.';
  }

  window.FansBrandsOrderSupport = {
    version: '20.3.0',
    fieldMeta: FIELD_META,
    normalize: normalize,
    validate: validate,
    secondaryKeys: secondaryKeys,
    configureInput: configureInput,
    safeUrl: safeUrl,
    statusModel: statusModel,
    paymentModel: paymentModel,
    pickupModel: pickupModel,
    renderOrder: renderOrder,
    noMatchMessage: noMatchMessage
  };
})();
